import { PrimaryButton } from "@humanpredictiveintelligence/myqvt-library"
import { t } from "ttag"
import { Dialog, DialogActions, DialogTitle } from "@material-ui/core"
import React from "react"

import { NotificationContext } from "features/Notification"
import * as Styles from "./ContactUsDialog.styles"

import { useCreateCustomerDemandMutation } from "graphql/mutations/generated/CreateCustomerDemand"
import business from "../../../../../config/business"

export const ContactUsDialog = () => {
  const notification = React.useContext(NotificationContext)

  const [ demand, setDemand ] = React.useState("")
  const [ isOpen, setIsOpen ] = React.useState(false)

  const [ createCustomerDemand, { loading: isCustomerDemandBeingProcessed } ] = useCreateCustomerDemandMutation()

  return (
    <Styles.Container>
      <Styles.ContactUsButton onClick={() => setIsOpen(true)}>
        {t`Contact our team`}
      </Styles.ContactUsButton>

      <Dialog
        open={isOpen}
        onClose={closeDialog}
      >
        <DialogTitle>{t`Contact us`}</DialogTitle>
        <Styles.Content>
          <Styles.DemandInput
            fieldClassNames="Field"
            isMandatory
            label={t`Your demand`}
            onChange={setDemand}
            rows={10}
            value={demand}
            showRemainingCharCount
            maxLength={500}
          />
        </Styles.Content>
        <DialogActions>
          <PrimaryButton
            destructive
            onClick={closeDialog}
            disabled={isCustomerDemandBeingProcessed}
          >
            {t`Cancel`}
          </PrimaryButton>
          <PrimaryButton
            onClick={() => sendDemand(demand)}
            isLoading={isCustomerDemandBeingProcessed}
            disabled={isDemandInvalid(demand)}
          >
            {t`Send`}
          </PrimaryButton>
        </DialogActions>
      </Dialog>
    </Styles.Container>
  )

  async function sendDemand(proposal: string): Promise<void> {
    try {
      await createCustomerDemand({
        variables: {
          body: proposal,
          subject: "Demande depuis de la page de SpeakUP non activé",
        },
      })
      notification.show(t`Success`, t`Your demand was sent successfully`, "success")
      closeDialog()
    }
    catch (error) {
      notification.show(t`Error`, t`Your demand could not be sent, please retry at a later date`, "danger")
      throw error
    }
  }

  function closeDialog(): void {
    setIsOpen(false)
    setDemand("")
  }

  function isDemandInvalid(demand: string): boolean {
    return !demand.length || demand.length > business.customerDemand.maxLength
  }
}
